import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Lato:wght@300;400;700&display=swap');

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${theme.fonts.body};
    background-color: ${theme.colors.background};
    color: ${theme.colors.text};
    line-height: 1.6;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.main};
    color: ${theme.colors.primary};
    margin-bottom: ${theme.spacing.md};
    font-weight: 600;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  p {
    margin-bottom: ${theme.spacing.md};
  }

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    transition: color ${theme.transitions.fast};

    &:hover {
      color: ${theme.colors.secondary};
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  button {
    cursor: pointer;
    font-family: ${theme.fonts.body};
  }

  ul, ol {
    margin-left: ${theme.spacing.lg};
    margin-bottom: ${theme.spacing.md};
  }

  section {
    padding: ${theme.spacing.xl} 0;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${theme.spacing.md};
  }

  .section-title {
    text-align: center;
    margin-bottom: ${theme.spacing.xl};
    position: relative;
    padding-bottom: ${theme.spacing.md};

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 3px;
      background-color: ${theme.colors.accent};
    }
  }

  .btn {
    display: inline-block;
    padding: ${theme.spacing.sm} ${theme.spacing.lg};
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
    border: none;
    border-radius: ${theme.borderRadius.small};
    font-weight: 600;
    transition: background-color ${theme.transitions.fast};

    &:hover {
      background-color: ${theme.colors.secondary};
      color: ${theme.colors.white};
    }

    &.btn-secondary {
      background-color: transparent;
      border: 2px solid ${theme.colors.primary};
      color: ${theme.colors.primary};

      &:hover {
        background-color: ${theme.colors.primary};
        color: ${theme.colors.white};
      }
    }

    &.btn-large {
      padding: ${theme.spacing.md} ${theme.spacing.xl};
      font-size: 1.1rem;
    }
  }

  .card {
    background-color: ${theme.colors.white};
    border-radius: ${theme.borderRadius.medium};
    box-shadow: ${theme.shadows.medium};
    overflow: hidden;
    transition: transform ${theme.transitions.medium}, box-shadow ${theme.transitions.medium};

    &:hover {
      transform: translateY(-5px);
      box-shadow: ${theme.shadows.large};
    }
  }

  .text-center {
    text-align: center;
  }

  .mb-1 {
    margin-bottom: ${theme.spacing.sm};
  }

  .mb-2 {
    margin-bottom: ${theme.spacing.md};
  }

  .mb-3 {
    margin-bottom: ${theme.spacing.lg};
  }

  .mb-4 {
    margin-bottom: ${theme.spacing.xl};
  }

  .mt-1 {
    margin-top: ${theme.spacing.sm};
  }

  .mt-2 {
    margin-top: ${theme.spacing.md};
  }

  .mt-3 {
    margin-top: ${theme.spacing.lg};
  }

  .mt-4 {
    margin-top: ${theme.spacing.xl};
  }

  /* Responsive styles */
  @media (max-width: ${theme.breakpoints.mobile}) {
    html {
      font-size: 14px;
    }

    .container {
      padding: 0 ${theme.spacing.sm};
    }

    section {
      padding: ${theme.spacing.lg} 0;
    }
  }
`;

export default GlobalStyles;
